// Multivariate Dependencies
import React from 'react';
// Components
import { TableHeader } from '../../../molecules/TableHeader';
// Hooks
import { useTable } from '../hooks/useTable';
export var TableStructure = function (_a) {
    var tableId = _a.tableId, columnConfigs = _a.columnConfigs, data = _a.data, initialState = _a.initialState, className = _a.className;
    var table = useTable(tableId, columnConfigs, data, initialState);
    return (React.createElement("table", { className: className },
        React.createElement("thead", null,
            React.createElement("tr", null, table.getFlatHeaders().map(function (header, index) {
                var _a = header.column.columnDef, headerTitle = _a.header, headerVariant = _a.meta.headerVariant, minSize = _a.minSize, maxSize = _a.maxSize;
                return (React.createElement(TableHeader, { key: index, styleVariant: headerVariant, minWidth: minSize, maxWidth: maxSize }, typeof headerTitle === 'string' ? headerTitle : ''));
            }))),
        React.createElement("tbody", null, table.getRowModel().rows.map(function (row) {
            var rowId = row.id, getVisibleCells = row.getVisibleCells;
            return (React.createElement("tr", { key: rowId }, getVisibleCells().map(function (visibleCell, index) {
                var CellComponent = visibleCell.column.columnDef.cell, getContext = visibleCell.getContext;
                var _a = getContext(), table = _a.table, column = _a.column, row = _a.row, cell = _a.cell, getValue = _a.getValue, renderValue = _a.renderValue;
                return (React.createElement(CellComponent, { table: table, column: column, row: row, cell: cell, getValue: getValue, renderValue: renderValue, key: index }));
            })));
        }))));
};
//# sourceMappingURL=TableStructure.js.map